import { companyGetDetailsReducer } from "../reducer/CompanyGetDetailsReducer";

export const reducer = companyGetDetailsReducer;
